export default __webpack_public_path__ + "static/media/Aviso_Horario.c815a760.png";